import axios from 'axios';
import axiosRetry from 'axios-retry';
import {merge, pick} from "lodash";


export default function HtmlRender(config)
{
    this.init(config);
}

HtmlRender.prototype = {

    defaultConfig: {
        baseURL: 'https://service.metrocreativeconnection.com/render/',
        timeout: 60000,
        networkRetries: 3 // network/server error retries(note timout applies to all...?)
    },

    init: function init(config) {
        this.config = merge({}, this.defaultConfig, config);
        var instanceOptions = pick(this.config, 'baseURL', 'timeout');
        this.client = axios.create(instanceOptions);

        // Network retries
        axiosRetry(this.client, {retries: this.config.networkRetries});
    },

    isOnLine: function isOnLine() {
        // Navigator is a browser only object
        return !navigator || navigator.onLine;
    },

    submitRequest: function (options) {

        if (!this.isOnLine()) {
            return Promise.reject({status: 1000}, 'offline').promise();
        }

        const callConfig = merge({
                url: options.queryPath,
                withCredentials: true,
                retries: this.config.commandRetries,
                responseType: 'json' //TBD other response type - assets, reports ....
            },
            options);

        // NOTE return whole response so caller can extract data || blob || whatever
        return this.client(callConfig)
            .catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    //OR
                    // and AOD status less than 0
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);

                throw error;
            });
    },

    // data = {html,filename, ?download, ?display}
    // download/display effect response headers
    render: function(data)
    {
        return this.submitRequest({
            queryPath: 'html',
            method: 'POST',
            responseType: 'blob',
            data
        }).then(response=>{
            return response.data;
        });
    }
};